import CONTROL_CUPBOARD from './CONTROL_CUPBOARD'
import LAMP_MODULE from './LAMP_MODULE'
import GROUP from './GROUP'

export default {
  CONTROL_CUPBOARD,
  LAMP_MODULE,
  GROUP,
}
